import { all, call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { getDefaultGridFilterModel } from '@mui/x-data-grid';
import { AxiosResponse } from 'axios';
import { getAssetsPaginated } from '../../services/asset';
import { addPolygonFilter } from '../../utils/filter';
import { Asset, PaginatedAssetsResponse } from '../AssetGrid/utils/types';
import {
	polygonFilterFetch,
	polygonFilterResolved,
	polygonFilterRejected,
	PolygonFilterFetchPayload,
} from './polygonHighlightSlice';

function* polygonFilterFetchSaga(
	action: PayloadAction<PolygonFilterFetchPayload>,
) {
	const { polygon, layers } = action.payload;

	const filterModel = addPolygonFilter(getDefaultGridFilterModel(), polygon);

	try {
		const results: Array<{ layerId: string; assetIds: string[] }> = yield all(
			layers.map(({ layerId, systemType, assetType }) =>
				call(async () => {
					// getAssetsPaginated returns an AxiosResponse at runtime despite
					// its type declaration — match the pattern used in AssetGrid saga.
					const res = (await getAssetsPaginated(
						systemType,
						assetType,
						5000,
						1,
						'assetId',
						undefined,
						filterModel,
					)) as unknown as AxiosResponse<PaginatedAssetsResponse>;
					const ids: string[] =
						res.data?.items?.map((i: Asset) => i._id) ?? [];
					return { layerId, assetIds: ids };
				}),
			),
		);

		yield put(
			polygonFilterResolved(
				Object.fromEntries(
					results.map(({ layerId, assetIds }) => [layerId, assetIds]),
				),
			),
		);
	} catch {
		yield put(polygonFilterRejected());
	}
}

function* watchPolygonFilterFetch() {
	yield takeLatest(polygonFilterFetch, polygonFilterFetchSaga);
}

export default [watchPolygonFilterFetch()];
